import { messages } from '#nuxt-prepare'
export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'de',
  messages,
  defaultLocale: 'de',
}))
